import { PropertyType } from 'components/filters/types';

export function getPluralPropertyTypeName(propertyType: PropertyType | null | undefined): string | null {
  if (!propertyType) return null;

  switch (propertyType) {
    case PropertyType.Hall:
      return 'halls';
    case PropertyType.Clinic:
      return 'clinics';
    case PropertyType.Hotel:
      return 'hotels';
    case PropertyType.Flat:
      return 'flats';
    case PropertyType.PrivateHouse:
      return 'villas';
    case PropertyType.GardenApartment:
      return 'garden-apartments';
    case PropertyType.Cottage:
      return 'cottages';
    case PropertyType.TwoFamilyDwelling:
      return 'dual-cottages';
    case PropertyType.PenthouseApp:
      return 'penthouse-apps';
    case PropertyType.Penthouse:
      return 'penthouses';
    case PropertyType.Rooftop:
      return 'attics';
    case PropertyType.Shop:
      return 'shops';
    case PropertyType.Duplex:
      return 'duplexes';
    case PropertyType.AgricultureLand:
      return 'agriculture-lands';
    case PropertyType.Land:
      return 'lands';
    case PropertyType.Building:
      return 'buildings';
    case PropertyType.Office:
      return 'offices';
    case PropertyType.Project:
      return 'projects';
    case PropertyType.RoofFlat:
      return 'roof-flats';
    case PropertyType.MiniPenthouse:
      return 'mini-penthouses';
    case PropertyType.ResidentialUnit:
      return 'residential-units';
    case PropertyType.SerialCottage:
      return 'serial-cottages';
    case PropertyType.Studio:
      return 'studios';
    case PropertyType.Triplex:
      return 'triplexes';
    case PropertyType.Basement:
      return 'basements';
    case PropertyType.Storeroom:
      return 'storerooms';
    case PropertyType.SplitFlat:
      return 'split-flats';
    case PropertyType.VacationProperty:
      return 'vacation-properties';
    case PropertyType.BuyerTeam:
      return 'buyer-teams';
    case PropertyType.ProfessionalFarm:
      return 'professional-farms';
    case PropertyType.Parking:
      return 'parkings';
    case PropertyType.Other:
      return 'others';
    case PropertyType.AgricultureFarm:
      return 'agriculture-farms';
    case PropertyType.Restaurant:
      return 'restaurants';
    case PropertyType.SharedWorkSpace:
      return 'shared-work-spaces';
    case PropertyType.ParkingLot:
      return 'parking-lots';
    case PropertyType.IndustrialBuilding:
      return 'industrial-buildings';
    case PropertyType.IncomeProducingProperty:
      return 'income-producing-properties';
    case PropertyType.FarmLand:
      return 'farm-lands';
    case PropertyType.Lab:
      return 'labs';
    default: {
      const exhaustiveCheck: never = propertyType;
      // tslint:disable-next-line: no-console
      console.warn(`Unhandled propertyType case: ${exhaustiveCheck}`);
      return null;
    }
  }
}
